module.exports = __webpack_public_path__ + "platform-web/static/media/dropdown-arrow-grey.7d8ce605.svg";